// ⚠️ GENERATED COPY — DO NOT EDIT.
// Source: shared/ui/journey/journeyTheme.ts — edit there, then run: bash scripts/sync_shared_code.sh
// CI verifies these copies match the source (sync_shared_code.sh --check).
// One palette for every journey component, so the plan-holder page, patient
// onboarding and the physician questionnaire cannot drift apart.
export const J = {
  paper: "#f5f0eb",
  ink: "#182a33",
  body: "#3f5260",
  muted: "#5b6e7c",
  teal: "#1b5e6e",
  sage: "#6b9c8e",
  amber: "#e8943a",
  line: "#e3ddd3",
  hairline: "#efe9e0",
  border: "#d8d2c8",
  white: "#ffffff",
  disabled: "#b9b3aa",
  tint: "#e8f1ee",
  shadow: "0 1px 2px rgba(24,42,51,.06), 0 6px 18px rgba(24,42,51,.06)",
  radiusCard: 16,
  radiusButton: 14,
} as const;

const KEYFRAMES_ID = "pj-journey-keyframes";
const KEYFRAMES_CSS =
  "@keyframes pj-fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}" +
  "@keyframes pj-pop{0%{transform:scale(.6);opacity:0}70%{transform:scale(1.08);opacity:1}100%{transform:scale(1)}}";

// Inline styles cannot declare keyframes, so one shared <style> is injected
// once per document; the guard keeps repeated mounts from stacking copies.
export function ensureJourneyKeyframes(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(KEYFRAMES_ID)) return;
  const el = document.createElement("style");
  el.id = KEYFRAMES_ID;
  el.textContent = KEYFRAMES_CSS;
  document.head.appendChild(el);
}

export function motionOk(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
